<script setup>
import { computed } from 'vue'

const props = defineProps({
  loading: Boolean,
  errorMsg: String,
  territorio: Object,
  terrKey: String,
  workedManzanas: { type: Array, default: () => [] },
})

// Réplica de la regla usada en SalidaPublica.vue: mzNumbers[0] es un placeholder,
// desde el índice 1 cada entrada trae el latlng del centro de la manzana.
const allManzanas = computed(() => {
  const mz = props.territorio?.mzNumbers
  if (!Array.isArray(mz) || mz.length <= 1) return []
  const result = []
  for (let i = 1; i < mz.length; i++) {
    if (mz[i]?.[0]) result.push(i)
  }
  return result
})

const faltantes = computed(() =>
  allManzanas.value.filter((i) => !props.workedManzanas.includes(i))
)
</script>

<template>
  <div class="simple-page">
    <img src="/territorios-icono.png" alt="Logo" class="simple-logo">

    <div v-if="loading" class="simple-loading">
      <i class="pi pi-spin pi-spinner" />
    </div>

    <div v-else-if="errorMsg" class="simple-error">{{ errorMsg }}</div>

    <div v-else-if="!territorio" class="simple-error">Territorio no encontrado.</div>

    <template v-else>
      <h1 class="simple-title">Territorio {{ terrKey }}</h1>

      <div v-if="!allManzanas.length" class="simple-msg">
        Este territorio no tiene manzanas registradas.
      </div>

      <div v-else-if="!faltantes.length" class="simple-done">
        <i class="pi pi-check-circle" />
        <div>¡Territorio completo!<br>Todas las manzanas fueron trabajadas.</div>
      </div>

      <template v-else>
        <div class="simple-field-label">Manzanas que faltan trabajar</div>
        <div class="simple-mz-grid">
          <span v-for="i in faltantes" :key="i" class="simple-mz-chip">{{ i }}</span>
        </div>
      </template>
    </template>
  </div>
</template>

<style scoped>
.simple-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px 20px 48px;
  background: var(--bg-grouped, #f2f2f7);
  text-align: center;
}

.simple-logo {
  width: 112px;
  height: 112px;
  margin-bottom: 28px;
}

.simple-loading {
  font-size: 2rem;
  color: var(--accent, #007aff);
  margin-top: 40px;
}

.simple-error,
.simple-msg {
  font-size: 18px;
  color: var(--label-secondary, #666);
  margin-top: 20px;
  max-width: 420px;
}

.simple-title {
  font-size: 28px;
  font-weight: 700;
  color: var(--label-primary, #111);
  margin: 0 0 24px;
}

.simple-done {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 24px;
  border-radius: 16px;
  background: var(--success-soft, #e3f7e8);
  color: var(--success-deep, #1e7d34);
  font-size: 18px;
  font-weight: 600;
  max-width: 420px;
}

.simple-done .pi {
  font-size: 2.4rem;
}

.simple-field-label {
  font-size: 15px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: var(--label-secondary, #666);
  margin-bottom: 14px;
}

.simple-mz-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(56px, 1fr));
  gap: 10px;
  width: 100%;
  max-width: 420px;
}

.simple-mz-chip {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 56px;
  border-radius: 12px;
  background: #fff;
  border: 2px solid var(--danger, #ff3b30);
  color: var(--danger, #ff3b30);
  font-size: 20px;
  font-weight: 700;
}
</style>
